// Copyright (C) 2019 TANNER AG

import gql from "graphql-tag";

export default gql`
    query buses {
        tcoBuses {
            id
            name
            doors
            type
            fuel
            efficientHybrid
        }
    }
`;



// WEBPACK FOOTER //
// ./src/tco/queries/buses.js